<template>
    <div class="">
        <body class="home page-template page-template-home-main page-template-home-main-php page page-id-222411 layout-home-page full-width overlay-effect-zoom-dark style-skin-1 context-home chrome wpb-js-composer js-comp-ver-4.3.5 vc_responsive">

        <header class="pipe-header sticky">
            <div class="pipe-container">
                <a href="https://www.mrdict.com/" title="MrDict" tabindex="1" class="pipe-logo">
                    <img alt="MrDict"
                         :src="require('../../assets/img/Logo_Full_Text.png')"/>
                </a>
                <ul class="pipe-menu">
                    <!--                    <li class="hidden-phone">-->
                    <!--                        <a href="https://app.pipefy.com/login/" title="Log in" tabindex="1" class="pipe-color-blue">Facebook</a>-->
                    <!--                    </li>-->
                    <li class=hidden-phone>
                        <a href="/" title="Log in" tabindex="1"
                           class="pipe-btn">Tải miễn phí</a>
                    </li>
                </ul>
            </div>
        </header>
        <div class="header-spacer"></div>
        <section class="hero parallax">
            <div class="container flexbox align-center space-between">
                <div class="text mover" data-direction="up" data-speed="5">
                    <h1>Tra từ điển dành cho người học IELTS</h1>
                    <h5 class="hero-caption">
                        Từ điển dựa trên nguồn Oxford Dictionary, Cambridge Dictionary, Thesaurus, từ điển Anh - Việt
                        chất lượng
                    </h5>
                    <a class="btn-blue" href="/">Cài
                        tiện ích trên Chrome/Cốc cốc</a>
                </div>
                <div class="img">
                    <!--                    <img src="https://cdn.dribbble.com/users/458522/screenshots/5348363/working_late.jpg" alt=""-->
                    <!--                         class="img-responsive">-->
                    <img :src="require('../../assets/img/homepage/img_header.jpg')"

                         class="img-responsive">
                </div>
            </div>
        </section>

        <section class="logo-band">
            <div class="container">
                <p>Tiện ích MrDict giúp bạn học từ vựng IELTS hiệu quả hơn. Được khuyên dùng bởi:</p>
                <ul class="flexbox align-center space-evenly">
                    <li>

                        <a href="https://www.facebook.com/groups/ieltsngocbach" target="_blank">
                            <img :src="require('../../assets/img/homepage/partner/TuHocIELTS_8.png')"
                                 class="attachment-medium size-medium" alt="Group Tự học IELTS 8.0"/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.facebook.com/tuhocIelts8.0/" target="_blank">
                            <img :src="require('../../assets/img/homepage/partner/IELTSNgocBach.png')"
                                 class="attachment-medium size-medium" alt="IELTS Ngoc Bach"/>
                        </a>
                    </li>

                </ul>
            </div>
        </section>


        <section class="benefit-grid">
            <div class="container">
                <h2>Tính năng nổi bật</h2>

                <ul class="flexbox space-between flex-row owl-carousel owl-theme">
                    <li>
                        <img src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/icon-guide-team-1.svg"
                             class="attachment-medium size-medium" alt="" height="42" width="34"/><h4>Tra từ điển nhiều
                        nguồn</h4>
                        <p>Tra từ điển nhiều nguồn (Oxford Dictionary, Cambridge Dictionary, Anh - Việt) cùng một
                            lúc</p>
                    </li>
                    <li>
                        <img src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/icon-improve-slas-1.svg"
                             class="attachment-medium size-medium" alt="" height="36" width="44"/><h4>Tra từ trong khi
                        lướt Web</h4>
                        <p>Chỉ cần nháy đúp vào từ</p>
                    </li>
                    <li>
                        <img src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/icon-find-bottlenecks-1.svg"
                             class="attachment-medium size-medium" alt="" height="39" width="39"/><h4>Lịch sử từ mới
                        xuất hiện trong New Tab</h4>
                        <p>Màn hình tra từ điển xuất hiện ngay khi mở Tab Mới</p>
                    </li>

                    <li>
                        <img src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/icon-prevent-fails-1.svg"
                             class="attachment-medium size-medium" alt="" height="46" width="44"/><h4>Tốc độ tra từ điển
                        cực nhanh</h4>
                        <p>Tra từ điển chỉ cần nháy đúp vào từ. Hoặc mở Tab mới để tra từ</p>
                    </li>
                    <li>
                        <img src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/icon-improve-response-1.svg"
                             class="attachment-medium size-medium" alt="" height="44" width="44"/><h4>Tăng khả năng hiểu
                        và nhớ
                        từ mới</h4>
                        <p>Mr Dict sẽ thường xuyên "nhắc" lại các cụm từ mới bạn chưa thuộc</p>
                    </li>
                    <li>
                        <img src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/icon-reduce-costs-1.svg"
                             class="attachment-medium size-medium" alt="" height="36" width="48"/><h4>Cụm từ
                        Speaking, Writing "ăn điểm"</h4>
                        <p>Nâng band từ vựng nhờ Synonyms và Collocations</p>
                    </li>
                </ul>
            </div>
        </section>

        <section class="box-callouts">
            <div class="container flexbox align-center space-between">
                <div class="text">
                    <h2>
                        Tất cả Từ điển trong một tiện ích <strong>Mr Dict</strong></h2>
                    <p>Cùng lúc tra từ nhiều nguồn từ điển chất lượng</p>

                    <a href="/" class="all">
                        Tìm hiểu thêm </a>
                </div>
                <ul class="flexbox align-center space-between flex-row">
                    <li style="background-color: #0081ff">
                        <a href="/">
                            <!--                            <img src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/icon-templates-operations-1.svg"-->
                            <!--                                 class="attachment-medium size-medium" alt="" height="40" width="38"/>-->
                            <i class="attachment-medium size-medium icon_center fas fa-book-open"></i>
                            <p>Oxford Dictionary</p>
                        </a>
                    </li>
                    <li style="background-color: #ffa61e">
                        <a href="/">
                            <i class="attachment-medium size-medium icon_center fas fa-book-open"></i>
                            <p>Cambridge Dictionary</p>
                        </a>
                    </li>
                    <li style="background-color: #ff7539">
                        <a href="/">
                            <i class="attachment-medium size-medium icon_center fas fa-book-open"></i>
                            <p>Từ điển Anh - Việt</p>
                        </a>
                    </li>
                    <li style="background-color: #5b005c">
                        <a href="/">

                            <i class="attachment-medium size-medium icon_center fas fa-language " style=""></i>
                            <p>Google Translate</p>
                        </a>
                    </li>
                    <li style="background-color: #00ce8c">
                        <a href="/">
                            <i class="attachment-medium size-medium icon_center fab fa-buffer"></i>
                            <p>Từ đồng nghĩa</p>
                        </a>
                    </li>
                    <li style="background-color: #ec4a2c">
                        <a href="/">
                            <i class="attachment-medium size-medium icon_center fas fa-book-open"></i>
                            <p>Idiom và Collocation</p>
                        </a>
                    </li>
                </ul>
            </div>
        </section>


        <section class="alt-rows ex-rows">
            <div class="container">
                <ul>
                    <li class="flexbox space-between back">
                        <div class="img">
                            <!--                            <img class="shapes mover"-->
                            <!--                                 src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/fill-1@2x-1.png" alt=""-->
                            <!--                                 data-direction="up" data-speed="5">-->
                            <!--                            <img class="parallax mover"-->
                            <!--                                 src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/12/automations-1.gif" alt=""-->
                            <!--                                 data-direction="up" data-speed="7">-->
                            <img :src="require('../../assets/img/homepage/search_new_tab.png')" alt=""
                                 class="img-responsive">
                        </div>
                        <div class="text">
                            <h4 class="mover" data-direction="up" data-speed="5">
                                Tra từ bất cứ khi nào mở <strong>New Tab</strong></h4>
                            <p class="mover" data-direction="up" data-speed="5">
                                Cài Mr Dict để tra từ ngay tại New Tab</p>
                            <div class="">
                                <span class="btn-blue" style="margin-top: 15px">Sử dụng ngay</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
        <!--        <section class="testimonials">-->
        <!--            <div class="container">-->
        <!--                <h2>-->
        <!--                    Lean managers around the world <strong>trust Pipefy</strong></h2>-->
        <!--                <img class="dots left"-->
        <!--                     src="https://tazvo5xtp725bken2dzfvl1d-wpengine.netdna-ssl.com/wp-content/themes/pipefy-wp-theme/ab-homepage/img/testimonial-dots.png"-->
        <!--                     srcset="/wp-content/themes/pipefy-wp-theme/ab-homepage/img/testimonial-dots@2x.png 2x, /wp-content/themes/pipefy-wp-theme/ab-homepage/img/testimonial-dots@3x.png 3x">-->
        <!--                <img class="dots right"-->
        <!--                     src="https://tazvo5xtp725bken2dzfvl1d-wpengine.netdna-ssl.com/wp-content/themes/pipefy-wp-theme/ab-homepage/img/testimonial-dots.png"-->
        <!--                     srcset="/wp-content/themes/pipefy-wp-theme/ab-homepage/img/testimonial-dots@2x.png 2x, /wp-content/themes/pipefy-wp-theme/ab-homepage/img/testimonial-dots@3x.png 3x">-->
        <!--                <ul class="flexbox space-between owl-carousel owl-theme">-->
        <!--                    <li>-->
        <!--                        <p>"Pipefy allows us to easily see exactly what we are working on, allowing us to streamline our-->
        <!--                            work-->
        <!--                            and save time."</p>-->
        <!--                        <span class="author">-->
        <!--          <span>-->
        <!--                  <img width="288" height="288"-->
        <!--                       src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/chirs-bennett.png"-->
        <!--                       class="attachment-full size-full" alt=""-->
        <!--                       srcset="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/chirs-bennett.png 288w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/chirs-bennett-150x150.png 150w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/chirs-bennett-240x240.png 240w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/chirs-bennett-100x100.png 100w"-->
        <!--                       sizes="(max-width: 288px) 100vw, 288px"/>                  </span>-->
        <!--          <p><strong>Chris Bennett</strong> Digital Communications Manager</p>-->
        <!--        </span>-->
        <!--                    </li>-->
        <!--                    <li>-->
        <!--                        <p>"Ease of use interface and the possibility to create my process management the way I need-->
        <!--                            with no IT-->
        <!--                            guy."</p>-->
        <!--                        <span class="author">-->
        <!--          <span>-->
        <!--                  <img width="288" height="288"-->
        <!--                       src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/christiano-machado.png"-->
        <!--                       class="attachment-full size-full" alt=""-->
        <!--                       srcset="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/christiano-machado.png 288w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/christiano-machado-150x150.png 150w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/christiano-machado-240x240.png 240w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/christiano-machado-100x100.png 100w"-->
        <!--                       sizes="(max-width: 288px) 100vw, 288px"/>                  </span>-->
        <!--          <p><strong>Cristiano Machado</strong> CEO</p>-->
        <!--        </span>-->
        <!--                    </li>-->
        <!--                    <li>-->
        <!--                        <p>"Pipefy has become my go to solution for all my clients when it comes to managing just about-->
        <!--                            anything."</p>-->
        <!--                        <span class="author">-->
        <!--          <span>-->
        <!--                  <img width="288" height="288"-->
        <!--                       src="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/torey-heinz.png"-->
        <!--                       class="attachment-full size-full" alt=""-->
        <!--                       srcset="https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/torey-heinz.png 288w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/torey-heinz-150x150.png 150w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/torey-heinz-240x240.png 240w, https://d2qfyj0q2n9d96.cloudfront.net/uploads/2018/11/torey-heinz-100x100.png 100w"-->
        <!--                       sizes="(max-width: 288px) 100vw, 288px"/>                  </span>-->
        <!--          <p><strong>Torey Heinz</strong> Founder</p>-->
        <!--        </span>-->
        <!--                    </li>-->
        <!--                </ul>-->
        <!--            </div>-->
        <!--        </section>-->

        <section class="outro">
            <div class="container">
                <h3>Tiện ích Mr Dict - Tra từ điển dành cho người học IELTS</h3>
                <a href="/" class="btn-blue">Cài đặt ngay</a>
            </div>
        </section>

        <!--        <section class="outro">-->
        <!--            <div class="container">-->
        <!--                <h3 style="font-size: 28px; margin-bottom: 0;">Theo dõi các cập nhật của Mr Dict</h3>-->
        <!--                <p style="text-align: center; color: #999">Nhận các tài liệu IETLS hữu ích và cập nhật của từ điển Mr-->
        <!--                    Dict</p>-->
        <!--                <form action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST"-->
        <!--                      style="max-width: 400px; margin: 0 auto;">-->
        <!--                    <label class="pipe-input-wrap" for="first_name" style="margin-bottom: 0">-->
        <!--                        <b class="pipe-label-text">Họ tên</b>-->
        <!--                        <input class="pipe-input" id="first_name" maxlength="40" name="first_name" size="20" type="text"-->
        <!--                               required="true">-->
        <!--                    </label>-->
        <!--                    <label class="pipe-input-wrap" for="email">-->
        <!--                        <b class="pipe-label-text">Email</b>-->
        <!--                        <input class="pipe-input" id="email" maxlength="80" name="email" size="20" type="text"-->
        <!--                               required="true">-->
        <!--                    </label>-->
        <!--                    <input class="btn-blue" type="submit" value="Đăng ký">-->
        <!--                </form>-->
        <!--            </div>-->

        <!--        </section>-->
        <!-- footer -->
        <div class="pipe-sub-footer">
            <div class="pipe-container">
    <span>
      <img alt="Golden Gate Bridge"
           :src="require('../../assets/img/Logo_Text.png')"/>
      © 2019 All Rights Reserved
    </span>
                <!-- <a href="/#pipefy-how" data-target="#pipe-modal-video" data-slug="pipefy-how" data-source="//player.vimeo.com/video/113230051?title=0&byline=0" title="See how Pipefy works" tabindex="1" class="pipefy-how pipe-play-footer-video">
                  <img alt="Play Triangle" src="https://tazvo5xtp725bken2dzfvl1d-wpengine.netdna-ssl.com/assets/images/play.svg" />
                  See how Pipefy works
                </a> -->
            </div>
        </div>
        <div class="pipe-modal pipefy-form" id="pipe-contact-form">
            <a href="#" class="pipe-close-modal pp-ico-close"></a>
            <div class="pipe-form-body">
                <div class="pipe-form-header">
                    <p class="pipe-title-2">Contact us</p>
                </div>

            </div>
        </div>

        </body>
    </div>
</template>

<script>
  export default {
    name: 'Main',
    components: {},
  }
</script>

<style scoped>
    @import "../../assets/page/homepage/homepage.css";
    @import "../../assets/page/homepage/main.css";
    @import "../../assets/page/homepage/style.css";

    .icon_center {
        color: #fff;
        font-size: 50px;
        top: 36px;
        left: 10px;
        right: 10px;
        margin: auto;
        z-index: 2;
        position: absolute;
    }
</style>
